/* ---------- Mesure d'audience Yolète (PostHog, hébergement Europe) ----------
   Un seul fichier pose tous les capteurs du site, par délégation d'événements :
   rien à modifier dans les autres scripts. Sans clé, rien n'est envoyé.
   Avant consentement : mesure sans cookie (mémoire seulement, pas de replay).
   Après consentement : cookies PostHog + enregistrement de session.
   Consentement : bandeau Shopify (Customer Privacy API) sur la boutique,
   bandeau maison (yoleteConsent) sur la copie de travail.
   Test : ajouter ?debug_analytics=1 à l'URL, les événements s'affichent dans la console
   et dans window.__yoEvents. */
window.YOLETE_ANALYTICS = window.YOLETE_ANALYTICS || {
  key: 'phc_nmU6uUsayMmqVhqSTVnLxBvem6MKmnHFaZdK8KGvxCMv',                                   /* clé de projet PostHog, commence par phc_ */
  host: 'https://eu.i.posthog.com',
  hosts: ['www.yolete.fr', 'yolete.fr'],     /* seuls hôtes mesurés (pas la copie Vercel) */
  meta: '',                                  /* identifiant du pixel Meta, posé depuis Personnaliser */
  googleAds: 'AW-18341925235'                /* balise Google Ads, chargée après accord publicitaire */
};
(function () {
  var CFG = window.YOLETE_ANALYTICS;
  /* Éditeur de thème (Personnaliser) : aucune mesure, sinon chaque réglage de
     Charlotte compterait comme une visite (10 oct 2026). */
  if (window.Shopify && Shopify.designMode) return;
  var DEBUG = (function () {
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var on = /debug_analytics=1/.test(location.search + location.hash + (nav.name || ''));
    try { if (on) sessionStorage.setItem('yo_debug', '1'); else if (/debug_analytics=0/.test(location.search)) sessionStorage.removeItem('yo_debug'); return on || !!sessionStorage.getItem('yo_debug'); } catch (e) { return on; }
  })();
  var LIVE = !!CFG.key && CFG.hosts.indexOf(location.hostname) >= 0;
  if (!LIVE && !DEBUG) return;
  window.__yoEvents = [];

  /* ---------- chargement PostHog ---------- */
  var ph = null;
  function loadPostHog(cb) {
    if (!LIVE) return cb();
    if (window.posthog && window.posthog.__loaded) { ph = window.posthog; return cb(); }
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init(CFG.key, {
      api_host: CFG.host,
      persistence: dejaConsenti() ? 'localStorage+cookie' : 'memory',   /* voir dejaConsenti() */
      disable_session_recording: true,
      capture_pageview: false,               /* envoyée à la main ci-dessous, avec la propriété page */
      capture_pageleave: true,
      autocapture: false,                    /* les capteurs métier ci-dessous suffisent, plus lisibles */
      capture_heatmaps: true,
      loaded: function (p) {
        ph = p;
        /* propriétés communes à TOUS les événements, page vue comprise :
           sans ça, la ventilation par « page » dans PostHog affiche « None ». */
        p.register({ page: page, largeur_page: largeurPage() });
        p.capture('$pageview');
        cb();
      }
    });
  }

  /* ---------- consentement ---------- */
  /* Le consentement est memorise par nos soins. Sans ca, posthog.init repartait en
     persistance memoire a CHAQUE page, generait un nouveau distinct_id et ecrasait le
     cookie : un visiteur = autant de personnes que de pages vues, et tout funnel qui
     traverse deux pages restait vide (constate le 16 sept 2026, 2 592 pages vues pour
     2 592 identites). On ne pose rien avant le premier accord. */
  var MEMO = 'yo_consent_ok';
  function dejaConsenti() {
    try { return localStorage.getItem(MEMO) === '1'; } catch (e) { return false; }
  }
  function granted() {
    try {
      if (window.Shopify && Shopify.customerPrivacy) return Shopify.customerPrivacy.analyticsProcessingAllowed();
      if (typeof yoleteConsent === 'function') return yoleteConsent() === 'accept';
    } catch (e) {}
    return false;
  }
  var full = false;
  function upgrade() {
    metaPose();
    googlePose();
    if (full || !granted()) return;
    full = true;
    try { localStorage.setItem(MEMO, '1'); } catch (e) {}
    if (ph) { ph.set_config({ persistence: 'localStorage+cookie', disable_session_recording: false }); ph.startSessionRecording(); }
    if (DEBUG) console.log('[yolete analytics] consentement : mesure complète');
  }
  function watchConsent() {
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { upgrade(); });
      document.addEventListener('visitorConsentCollected', upgrade);
    }
    document.addEventListener('yolete:consent', upgrade);
    upgrade();
  }

  /* ---------- pixel Meta ----------
     Chargé seulement après accord publicitaire, jamais avant. Si le canal
     Facebook et Instagram de Shopify a déjà posé son pixel, window.fbq existe
     et on ne touche à rien, sinon chaque événement partirait en double.
     L'achat n'est pas ici, il se produit sur la page de paiement que le thème
     ne contrôle pas. Il vient du canal Shopify ou de l'API de conversions. */
  var META = { pose: false, id: String(CFG.meta || window.YOLETE_META_PIXEL || '').replace(/\D/g, '') };
  function metaAutorise() {
    try {
      if (window.Shopify && Shopify.customerPrivacy) return Shopify.customerPrivacy.marketingAllowed();
      if (typeof yoleteConsent === 'function') return yoleteConsent() === 'accept';
    } catch (e) {}
    return false;
  }
  function metaPose() {
    if (META.pose || !META.id || !LIVE || !metaAutorise()) return;
    if (window.fbq) { META.pose = true; return; }   /* déjà posé par le canal Shopify */
    META.pose = true;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', META.id);
    fbq('track', 'PageView');
    if (DEBUG) console.log('[yolete analytics] pixel Meta posé', META.id);
  }
  /* Correspondance entre les événements du site et le vocabulaire de Meta. */
  var META_EVENTS = {
    produit_vu: 'ViewContent', composeur_vu: 'ViewContent',
    produit_ajout: 'AddToCart', panier_ajout: 'AddToCart', composeur_ajout: 'AddToCart',
    commande_clic: 'InitiateCheckout', express_clic: 'InitiateCheckout',
    newsletter_inscription: 'Lead', recherche: 'Search'
  };
  function metaTrack(name, props) {
    if (!META.pose || !window.fbq) return;
    var e = META_EVENTS[name]; if (!e) return;
    var d = {};
    if (props.reference || props.produit) d.content_name = props.reference || props.produit;
    if (props.prix) { d.value = props.prix; d.currency = 'EUR'; }
    if (name === 'recherche' && props.texte) d.search_string = props.texte;
    try { fbq('track', e, d); } catch (err) {}
  }

  /* ---------- balise Google Ads ----------
     Même règle que le pixel Meta : gtag.js ne se charge qu'après l'accord
     publicitaire du bandeau, jamais avant (mode de consentement « de base » de
     Google). Le choix du visiteur lui est transmis, et s'il le retire ensuite,
     la balise passe en refusé. L'achat se mesure sur la page de paiement, que le
     thème ne contrôle pas : application Google & YouTube ou pixel client Shopify,
     avec l'étiquette de conversion donnée par Google Ads (8 oct 2026). */
  var GADS = { pose: false, id: String(CFG.googleAds || '').trim() };
  function googleConsent() {
    var pub = metaAutorise() ? 'granted' : 'denied';
    return { ad_storage: pub, ad_user_data: pub, ad_personalization: pub, analytics_storage: granted() ? 'granted' : 'denied' };
  }
  function googlePose() {
    if (!GADS.id || !LIVE) return;
    if (GADS.pose) { window.gtag('consent', 'update', googleConsent()); return; }
    if (!metaAutorise()) return;
    GADS.pose = true;
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', googleConsent());
    var s = document.createElement('script'); s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GADS.id);
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', GADS.id);
    if (DEBUG) console.log('[yolete analytics] balise Google Ads posée', GADS.id);
  }

  /* ---------- capture ---------- */
  var page = (function () {
    var p = location.pathname.replace(/^\/pages\//, '/').replace(/\.html$/, '').replace(/^\/$/, '/accueil');
    return p.replace(/^\//, '');
  })();
  function track(name, props) {
    props = props || {}; props.page = page; props.largeur_page = largeurPage();
    if (DEBUG) { console.log('[yolete analytics]', name, props); window.__yoEvents.push({ e: name, p: props }); }
    if (ph) ph.capture(name, props);
    metaTrack(name, props);
  }
  window.yoTrack = track;
  /* Exposes pour verifier une reference sans rejouer un parcours complet :
     yoRef(PRODUCTS.find(p => p.id === 'boucle-n213'))  ->  'N214' */
  window.yoRef = refLisible;
  window.yoProduit = produit;

  function largeurPage() {
    var q = new URLSearchParams(location.search);
    if (q.get('w')) return +q.get('w');
    if (typeof width !== 'undefined' && (width === 25 || width === 40)) return width;
    return null;
  }
  /* ---------- identité d'une pièce ----------
     ATTENTION, piège de fond : l'identifiant d'URL Shopify (le « handle »)
     MENT sur la référence pour 34 des 180 boucles. « boucle-n213 » est en
     réalité la N214, « boucle-n218 » la N350, « boucle-n248 » la N239.
     Tant que PostHog recevait ce handle dans un champ nommé « ref », toute
     ventilation affichait des références qui n'existent pas sur le site.
     On envoie donc trois champs distincts :
       reference -> le code lisible, celui du site et des books (N214)
       handle    -> l'identifiant d'URL, pour remonter à la fiche
       nom       -> le libellé complet (BOUCLE N214)
     « ref » garde son nom d'origine, pour ne pas casser les graphiques
     existants, mais porte enfin la vraie référence. */
  function refLisible(p) {
    if (!p) return null;
    var n = String(p.name || '').trim();
    /* « BOUCLE N20 » en francais, « BUCKLE N20 » en anglais : sans retirer les
       deux, le meme produit remonte sous deux libelles et la ventilation se
       coupe en deux. */
    var m = n.match(/^(?:BOUCLE|BUCKLE)\s+(.+)$/i);
    n = (m ? m[1] : n).trim();
    /* Les TIGES portent le meme nom en 25 et en 40 mm (« Tige Preto Noir »
       existe deux fois) : sans la largeur, deux produits distincts se
       confondent. Les boucles, elles, distinguent deja les largeurs dans leur
       nom (N20 et N20/25) : ne rien ajouter, « N20 » est la reference que la
       maison emploie. */
    if (p.type === 'tige' && p.width && !/\b(25|40)\b/.test(n)) n += ' · ' + p.width + ' mm';
    return n || p.id || null;
  }

  /* Combien de fiches du catalogue portent la meme reference ? Shopify nomme
     8 boucles differentes « BOUCLE N350 » et 5 « BOUCLE N348 » (visuels et
     handles distincts, meme nom). Grouper sur la reference les fusionne donc
     en une seule ligne. On ne peut pas deviner la bonne reference a leur
     place, mais on peut le SIGNALER : `ref_partagee` vaut true quand la ligne
     agrege plusieurs fiches, pour ne jamais lire un total comme un produit. */
  var _indexRef = null;
  function refPartagee(p) {
    if (!p) return null;
    if (!_indexRef) {
      _indexRef = {};
      try {
        PRODUCTS.forEach(function (x) {
          var r = refLisible(x); if (r) _indexRef[r] = (_indexRef[r] || 0) + 1;
        });
      } catch (e) { return null; }
    }
    var r = refLisible(p);
    return r ? (_indexRef[r] || 0) > 1 : null;
  }
  function produit(id) {
    if (!id || typeof PRODUCTS === 'undefined') return null;
    var p = PRODUCTS.find(function (x) { return x.id === id; }); if (!p) return null;
    var r = refLisible(p);
    return { ref: r, reference: r, handle: p.id, nom: p.name, type: p.type,
             ref_partagee: refPartagee(p),
             largeur: p.width || p.largeur || null, prix: p.price };
  }
  /* Aucun événement produit ne doit partir avec le seul handle : sans le nom,
     la ventilation PostHog retombe sur l'identifiant d'URL et ment. Quand la
     pièce est introuvable dans le catalogue on le dit, au lieu de faire passer
     un handle pour une référence. */
  function produitOu(id, extra) {
    var base = produit(id);
    if (!base) base = { ref: null, reference: null, handle: id || null, nom: null, inconnu: true };
    return merge(base, extra || {});
  }
  function merge(a, b) { var o = {}; for (var k in a) o[k] = a[k]; for (var j in b) o[j] = b[j]; return o; }
  /* Nom de la SECTION d'où part le clic (« Nos boucles bijoux », « Vous aimerez
     aussi »...). Piège : `querySelector('h1,h2,h3')` renvoyait le PREMIER titre
     de la section, cartes produit comprises — chaque carte porte un h3. Sur la
     boutique, tous les clics étaient donc étiquetés du nom de la première carte
     (« Boucle N01 »), ce qui faisait passer un compte de clics par section pour
     un compte de vues par boucle. On ignore les titres situés dans une carte. */
  /* Un titre coupe par <br> (« Le bijou<br>de taille. ») donne « Le bijoude
     taille. » avec textContent : les retours a la ligne ne sont pas des
     espaces. On remplace donc les balises par une espace. */
  function titre(h) {
    return String(h.innerHTML || '').replace(/<[^>]+>/g, ' ')
      .replace(/&[a-z]+;/gi, ' ').replace(/\s+/g, ' ').trim().slice(0, 60);
  }
  function bloc(el) {
    var s = el.closest('section, .reco, .related, aside, main'); if (!s) return null;
    var hs = s.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < hs.length; i++) {
      if (!hs[i].closest('.card, article')) return titre(hs[i]);
    }
    /* Section sans titre propre (la grille boutique) : on nomme le conteneur. */
    var g = el.closest('[id]');
    return s.id || (g && g.id) || (String(s.className || '').split(/\s+/)[0] || null);
  }
  function selCompo() {
    /* Mêmes précautions que produit() : le composeur manipule des handles. */
    try {
      return {
        tige: sel.tige && sel.tige.id, boucle: sel.boucle && sel.boucle.id,
        tige_nom: sel.tige && sel.tige.name, boucle_ref: refLisible(sel.boucle),
        largeur: width, prix: (sel.tige.price || 0) + (sel.boucle.price || 0)
      };
    } catch (e) { return {}; }
  }
  function lignesPanier() {
    try {
      if (window.__yoleteCart) return __yoleteCart.items().length + __yoleteCart.pending.length;
      if (typeof cart !== 'undefined') return cart.length;
    } catch (e) {} return null;
  }
  function totalPanier() {
    var t = document.getElementById('drawerTotal'); if (!t) return null;
    var n = parseFloat(t.textContent.replace(/[^\d,]/g, '').replace(',', '.')); return isNaN(n) ? null : n;
  }

  function armer() {
    /* page produit */
    var q = new URLSearchParams(location.search), pid = q.get('id') || q.get('p');
    if (/produit/.test(location.pathname) && pid) track('produit_vu', produitOu(pid));
    if (/personnalisation/.test(location.pathname)) track('composeur_vu', selCompo());
    if (/panier|cart/.test(location.pathname)) track('panier_page');

    /* Boutons de paiement rapide (Shop Pay, Apple Pay, PayPal).
       Shopify ne rend ni <button> ni <a> dans ce bloc, mais des éléments sur mesure
       (shop-pay-wallet-button, shopify-paypal-button) et parfois une iframe. Le filtre
       « button, a » du gestionnaire de clic plus bas les écartait tous : express_clic
       restait à zéro alors que 54 % des commandes des 14 derniers jours passent par un
       portefeuille (relevé du 22 sept 2026). On les capte donc à part, sur pointerdown,
       qui part avant la redirection. */
    function nomPortefeuille(el) {
      for (var n = el; n && n.id !== 'yolete-express'; n = n.parentElement) {
        var t = String(n.tagName || '').toLowerCase();
        if (t.indexOf('shop-pay') >= 0) return 'Shop Pay';
        if (t.indexOf('paypal') >= 0) return 'PayPal';
        if (t.indexOf('apple') >= 0) return 'Apple Pay';
        if (t.indexOf('google') >= 0) return 'Google Pay';
        if (t === 'iframe') return 'iframe';
        if (t.indexOf('-') > 0) return t.slice(0, 40);
      }
      return 'express';
    }
    var dernierExpress = 0;
    function clicExpress(moyen) {
      var now = Date.now(); if (now - dernierExpress < 1500) return;   /* pointerdown puis blur : un seul clic */
      dernierExpress = now;
      track('express_clic', { moyen: moyen, total: totalPanier(), lignes: lignesPanier() });
    }
    document.addEventListener('pointerdown', function (e) {
      var c = e.target && e.target.closest && e.target.closest('#yolete-express');
      if (c) clicExpress(nomPortefeuille(e.target));
    }, true);
    /* Apple Pay et PayPal peuvent ouvrir leur feuille depuis une iframe : le pointerdown
       n'atteint alors pas la page, mais le focus bascule sur cette iframe. */
    window.addEventListener('blur', function () {
      setTimeout(function () {
        var a = document.activeElement;
        if (a && a.tagName === 'IFRAME' && a.closest && a.closest('#yolete-express')) clicExpress(nomPortefeuille(a));
      }, 0);
    });
    /* Combien de visiteurs voient réellement ces boutons : sans ce dénominateur, un
       express_clic bas ne dit pas si c'est le bouton ou son affichage qui manque. */
    var expressVu = false;
    function voirExpress() {
      if (expressVu) return;
      var ex = document.getElementById('yolete-express');
      if (!ex || ex.hidden || ex.getBoundingClientRect().height < 10) return;
      expressVu = true;
      var noms = [];
      [].forEach.call(ex.querySelectorAll('*'), function (n) {
        var m = nomPortefeuille(n);
        if (/Shop Pay|PayPal|Apple Pay|Google Pay/.test(m) && noms.indexOf(m) < 0) noms.push(m);
      });
      track('express_affiche', { moyens: noms.join(', ') || 'aucun', nombre: noms.length, total: totalPanier() });
    }
    window.yoVoirExpress = voirExpress;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('button, a, [data-tige], [data-boucle]'); if (!t) return;
      var d = t.dataset || {};
      if (d.tige) return track('composeur_tige', merge(selCompo(), { choix: d.tige }));
      if (d.boucle) return track('composeur_boucle', merge(selCompo(), { choix: d.boucle }));
      if (d.bstyle) return track('composeur_style', { style: d.bstyle });
      if (t.id === 'addCustom') return track('composeur_ajout', selCompo());
      if (t.classList.contains('csw')) return track('produit_coloris', produitOu(pid, { coloris: d.name || d.idx }));
      if (t.classList.contains('thumb')) return track('produit_photo', produitOu(pid));
      if (t.closest('#tailleChips')) return track('composeur_taille', merge(selCompo(), { taille: d.size }));
      if (t.classList.contains('pd-chip')) return track('produit_taille', produitOu(pid, { taille: d.size }));
      if (t.id === 'addProduct') { var s = document.querySelector('.pd-chip.active'); return track('produit_ajout', produitOu(pid, { taille: s ? s.dataset.size : null })); }
      if (t.id === 'sizeGuide' || /guide des tailles/i.test(t.textContent)) return track('guide_tailles');
      if (d.remove !== undefined) return track('panier_retrait', { lignes: lignesPanier() });
      if (d.qd !== undefined) return track('panier_quantite', { sens: +d.d > 0 ? 'plus' : 'moins' });
      if (t.closest('#drawerFoot') && t.classList.contains('btn')) return track(t.hasAttribute('data-guide') ? 'panier_guide_taille' : 'commande_clic', { total: totalPanier(), lignes: lignesPanier() });
      if (t.closest('#yolete-express')) return;     /* déjà compté sur pointerdown, plus haut */
      if (t.id === 'burger') return track('menu_ouvert');
      if (t.matches('[data-c]') && t.closest('.cookies')) return track('cookies_' + d.c);
      /* Clic sur une carte produit. PIEGE : le selecteur `a[href*="produit"]`
         attrape aussi les liens de NAVIGATION vers /pages/produits (menu,
         « voir tout », filtres). Ils n'ont pas d'identifiant, donc 38 % des
         `carte_clic` remontaient sans aucune reference et gonflaient le total
         d'un tiers. On n'emet l'evenement que si un produit est reellement
         designe ; sinon c'est de la navigation, suivie a part. */
      var card = t.closest('a.card, .card a, a[href*="produit"]');
      if (card) {
        var href = card.getAttribute('href') || '';
        var m = href.match(/[?&]id=([^&#]+)/) || href.match(/\/products\/([^/?#]+)/);
        if (m) return track('carte_clic', produitOu(decodeURIComponent(m[1]), { bloc: bloc(t) }));
        if (/\/pages\/produits|produits\.html|\/collections\//.test(href))
          return track('lien_catalogue', { destination: href.slice(0, 80), bloc: bloc(t) });
        return;
      }
      if (t.tagName === 'A' && /^https?:/.test(t.href) && t.hostname !== location.hostname) return track('lien_externe', { url: t.href });
      if (t.tagName === 'A' && /\.pdf($|\?)/i.test(t.href)) return track('pdf_ouvert', { url: t.href });
    }, true);

    document.addEventListener('change', function (e) {
      var s = e.target.closest('.dl-size'); if (s && s.value) track('panier_taille', { taille: s.value, lignes: lignesPanier() });
      var f = e.target.closest('select[data-filter], .filter select'); if (f) track('filtre', { nom: f.name || f.id, valeur: f.value });
    }, true);

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.matches('.nl-form, .js-signup, form[action*="contact"]')) track('newsletter_inscription', { source: f.closest('.nl-pop, .newsletter, footer') ? (f.closest('.nl-pop') ? 'fenetre' : 'pied de page') : 'page' });
      else if (f.matches('form[action*="search"], .search-form')) track('recherche', { requete: (f.querySelector('input[type=search], input[name=q]') || {}).value });
      else if (f.matches('form')) track('formulaire', { id: f.id || f.className });
    }, true);

    document.addEventListener('play', function (e) { if (e.target.tagName === 'VIDEO') track('film_lecture', { src: (e.target.currentSrc || '').split('/').pop() }); }, true);

    /* panier : ouverture et ajouts (fonctions globales enveloppées) */
    ['openDrawer', 'cartAdd', 'addToCart'].forEach(function (fn) {
      var orig = window[fn]; if (typeof orig !== 'function') return;
      window[fn] = function () {
        try {
          if (fn === 'openDrawer') {
            track('panier_ouvert', { lignes: lignesPanier(), total: totalPanier() });
            /* les boutons de portefeuille arrivent après un aller-retour réseau */
            [700, 2000].forEach(function (d) { setTimeout(voirExpress, d); });
          }
          else {
            /* La ligne de panier ne transporte que le handle : on repasse par le
               catalogue pour retrouver la vraie référence, sinon « boucles vues
               vs ajoutées au panier » compare deux nommages différents. */
            var l = arguments[0], ex;
            if (l && typeof l === 'object') {
              ex = { variante: l.vlabel };
              if (l.type) ex.type = l.type;
              if (typeof l.price === 'number') ex.prix = l.price;
              track('panier_ajout', produitOu(l.id, ex));
            } else {
              track('panier_ajout', produitOu(l, { variante: arguments[1] }));
            }
          }
        } catch (err) {}
        return orig.apply(this, arguments);
      };
    });

    /* profondeur de lecture */
    var marks = [50, 90], seen = {};
    window.addEventListener('scroll', function () {
      var h = document.documentElement, pct = (h.scrollTop + innerHeight) / h.scrollHeight * 100;
      marks.forEach(function (m) { if (pct >= m && !seen[m]) { seen[m] = 1; track('page_profondeur', { pct: m }); } });
    }, { passive: true });
  }

  loadPostHog(function () { watchConsent(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armer); else armer(); });
})();
